export default "__VITE_ASSET__Cih5Ke1M__"